module.exports = __webpack_public_path__ + "static/img/code.7bbc28d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/code.png
// module id = xDq9
// module chunks = 2